export default {
  ADDRESS: 'address',
  STREET: 'street',
  CITY: 'city',
  DISTRICT: 'district',
  REGION: 'region',
};
